import script from "./presensi.vue?vue&type=script&setup=true&lang=ts"
export * from "./presensi.vue?vue&type=script&setup=true&lang=ts"

import "./presensi.vue?vue&type=style&index=0&id=ea601cce&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea601cce"]])

export default __exports__